const punctuation = /[!"#$%&'()*+,./:;<=>?@[\]^_`{|}~]/g

export default (id, title) => `/post/${id}/${title.replace(punctuation, '').replace(/\s/gi, '_')}`
